/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { useAppSelector } from '../../../reducers';
import { Loader } from '@g17eco/atoms/loader';
import { MessageFormProps, MessageFormField, MessageFormUserMin } from '../types';
import { DestinationCheckboxFields } from './DestinationCheckboxFields';
import { MessageField } from './MessageField';
import { SubjectField } from './SubjectField';
import { UserSelectField } from './UserSelectField';
import { useGetInitiativeUsersQuery } from '@api/manage-users';

interface UserMessageFormProps extends MessageFormProps {
  userIds: string[];
  users?: MessageFormUserMin[];
}

export const UserMessageForm = (props: UserMessageFormProps) => {
  const { onChange, form, users = [] } = props;

  const initiativeId = useAppSelector((state) => (state.initiative.loaded ? state.initiative.data._id : undefined));
  const { data = { users: [] }, isFetching } = useGetInitiativeUsersQuery(
    // @TODO: should this include subsidiaries? Seems likely?
    { initiativeId: initiativeId ?? '', includeSubsidiaries: false },
    {
      skip: !initiativeId || !!users.length,
    }
  );

  if (isFetching) {
    return <Loader />;
  }

  return (
    <div className='d-flex flex-column'>
      <UserSelectField
        users={users.length ? users : data.users}
        userIds={form.userIds}
        onChange={onChange(MessageFormField.UserIds)}
      />
      <SubjectField subject={form.subject} onChange={onChange(MessageFormField.Subject)} />
      <MessageField message={form.message} onChange={onChange(MessageFormField.Message)} />
      <DestinationCheckboxFields sendByEmail={form.sendByEmail} onChange={onChange(MessageFormField.SendByEmail)} />
    </div>
  );
};
